import Cookies from 'js-cookie'

const setExpirationTime = (minutes) => {
  return new Date(new Date().getTime() + minutes * 60 * 1000);
};
export const cookieOption = {
  ...(process.env.COOKIE_SECURE && process.env.REACT_APP_COOKIE_SECURE !== 'false' ? { secure: true } : {}),
  ...(process.env.COOKIE_SAME_SITE ? { sameSite: process.env.REACT_APP_COOKIE_SAME_SITE } : { sameSite: 'Strict' })
}

export const setCookie = ({ name = '', value = '', addExpirationTime = false, expirationTime = 120 }) => {
  if (!name || !value) {
    console.log(`Invalid Cookie cookie name or value missing`)
    return
  }
  Cookies.set(name, value, {
    ...cookieOption,
    ...(addExpirationTime ? { expires: setExpirationTime(expirationTime) } : {}),
  })
}

let last401ToastTimestamp = 0;

/**
 * Determines whether a 401 session expiration toast notification should be displayed,
 * throttling rapid concurrent 401 errors within the specified window.
 * @param {number} [throttleWindowMs=5000] - Minimum interval in milliseconds between 401 toast notifications.
 * @returns {boolean} True if the toast should be shown, false if throttled.
 */
export const shouldShow401Toast = (throttleWindowMs = 5000) => {
  const now = Date.now();
  if (now - last401ToastTimestamp > throttleWindowMs) {
    last401ToastTimestamp = now;
    return true;
  }
  return false;
};

